import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary'; // <--- Error Boundary یہاں امپورٹ کی گئی ہے
import reportWebVitals from './reportWebVitals';

// --- یہ لائنز ایپ رینڈر ہونے سے پہلے تھیم سیٹ کر دیں گی ---
try {
  const storedTheme = localStorage.getItem('app_theme') || 'dark';
  document.documentElement.setAttribute('data-theme', storedTheme);
} catch (e) {
  console.error("Failed to load theme early", e);
}
// -----------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Error Boundary کو App کے گرد لگا دیا گیا ہے */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();